import { defineMessages } from 'react-intl-next';

export default defineMessages({
	hubStudioLoadingSpinnerLabel: {
		id: 'hub-editor.loading-spinner-label',
		defaultMessage: 'Loading hub',
		description: 'Label for the hub editor loading spinner',
	},
});
